// extracted by mini-css-extract-plugin
export default {"main":"bestuur_main__CTKm-","flex_container":"bestuur_flex_container__cNhmy","flex_item":"bestuur_flex_item__n67MQ"};